import React, { useState } from 'react';
import { SectionWrapper } from './SectionWrapper';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el material después de comprar?',
  a: 'Inmediatamente después del pago recibís un mail con el link de descarga de todos los PDFs. El acceso es de por vida.'
}, {
  q: '¿Sirve si atiendo adultos pero también tengo pacientes menores?',
  a: 'Sí. Si parte de tu práctica incluye niños y adolescentes, este sistema te da el marco legal y clínico específico que no encontrás en los recursos para adultos.'
}, {
  q: '¿Está en español argentino?',
  a: 'Todo el contenido está escrito en español rioplatense, adaptado a la legislación argentina, con referencias a la Ley 26.061, el sistema judicial de familia argentino y los organismos de protección del país.'
}, {
  q: '¿Los 6 bonos están incluidos en las dos ofertas?',
  a: 'Sí. Los 6 bonos están incluidos tanto en el PRO como en el Elite. La diferencia es el Blindaje Legal Infantojuvenil Total que se suma en la opción Elite.'
}, {
  q: '¿Sirve para el concurso de ingreso a residencia infantojuvenil?',
  a: 'Sí. El manejo de situaciones complejas, el conocimiento legal específico y los protocolos clínicos adaptados a menores te diferencian en la evaluación del concurso.'
}, {
  q: '¿Qué diferencia tiene con los recursos de psiquiatría general?',
  a: 'Los recursos generales no contemplan las especificidades legales y clínicas de trabajar con menores: consentimiento, responsabilidad parental, Ley 26.061, denuncia obligatoria, informe para juzgado de familia. Este sistema está diseñado exclusivamente para eso.'
}, {
  q: '¿Para qué nivel está pensado?',
  a: 'Para psiquiatras infantojuveniles en ejercicio, residentes de la especialidad, psiquiatras generales que atienden menores y profesionales que se preparan para el concurso de residencia infantojuvenil.'
}, {
  q: '¿Por qué elegir el Elite y no el PRO base?',
  a: 'El PRO te da todo el sistema clínico. El Elite agrega el sistema de protección legal específico para casos con menores, donde la exposición legal es significativamente mayor que en adultos. Si trabajás con niños y adolescentes, la pregunta no es si vas a enfrentar una situación legal compleja sino cuándo.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <SectionWrapper data-id="element-87">
      <div className="text-center mb-6 md:mb-10" data-id="element-88">
        <p className="text-blue-600 font-bold tracking-wider text-[10px] md:text-xs uppercase mb-2 md:mb-3" data-id="element-89">
          Dudas Comunes
        </p>
        <h2 className="text-[22px] md:text-3xl font-extrabold text-[#0a1f44] tracking-tight" data-id="element-90">
          Preguntas Frecuentes
        </h2>
      </div>

      <div className="max-w-3xl mx-auto space-y-2 md:space-y-3" data-id="element-91">
        {faqs.map((faq, i) => {
        const isOpen = openIndex === i;
        return <div key={i} className="border border-slate-200/80 rounded-2xl overflow-hidden bg-white shadow-sm ring-1 ring-slate-900/5" data-id="element-92">
              <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full px-4 py-3.5 md:px-5 md:py-4 text-left flex items-center justify-between focus:outline-none hover:bg-slate-50 transition-colors" data-id="element-93">
                <span className="font-bold text-slate-800 text-[13px] md:text-base pr-4 leading-snug" data-id="element-94">
                  {faq.q}
                </span>
                <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-slate-400 shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-blue-500' : ''}`} data-id="element-95" />
              </button>
              <AnimatePresence data-id="element-96">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-97">
                    <div className="px-4 pb-4 md:px-5 md:pb-4 text-slate-600 text-[13px] md:text-sm leading-relaxed pt-0" data-id="element-98">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </SectionWrapper>;
}